(function () {
  'use strict';
  var selector = '[data-section-type="product-main"] > .product-right > h1.product-name';
  var titles = new Map();

  function fit(entry) {
    var title = entry.title;
    if (!title.isConnected || !title.clientWidth) return;
    if (entry.originalSize) title.style.setProperty('font-size', entry.originalSize, entry.originalPriority);
    else title.style.removeProperty('font-size');
    var style = getComputedStyle(title);
    var maximum = parseFloat(style.fontSize);
    var available = title.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) - 2;
    if (available <= 0 || !maximum) return;
    var range = document.createRange();
    range.selectNodeContents(title);
    var width = range.getBoundingClientRect().width;
    if (width > available) {
      var low = 1;
      var high = maximum;
      for (var i = 0; i < 10; i += 1) {
        var size = (low + high) / 2;
        title.style.setProperty('font-size', size + 'px', entry.originalPriority);
        if (range.getBoundingClientRect().width <= available) low = size;
        else high = size;
      }
      title.style.setProperty('font-size', Math.floor(low * 10) / 10 + 'px', entry.originalPriority);
    }
  }

  function schedule(entry) {
    if (entry.frame) return;
    entry.frame = requestAnimationFrame(function () { entry.frame = 0; fit(entry); });
  }

  function refresh() { titles.forEach(schedule); }

  function init() {
    titles.forEach(function (entry, title) {
      if (title.isConnected) return;
      if (entry.resize) entry.resize.disconnect();
      entry.mutation.disconnect();
      cancelAnimationFrame(entry.frame);
      titles.delete(title);
    });
    document.querySelectorAll(selector).forEach(function (title) {
      if (titles.has(title)) return;
      var entry = {title: title, frame: 0, width: -1,
        originalSize: title.style.getPropertyValue('font-size'),
        originalPriority: title.style.getPropertyPriority('font-size')};
      titles.set(title, entry);
      entry.mutation = new MutationObserver(function () { schedule(entry); });
      entry.mutation.observe(title, {childList: true, characterData: true, subtree: true});
      if ('ResizeObserver' in window) {
        entry.resize = new ResizeObserver(function () {
          if (entry.width === title.clientWidth) return;
          entry.width = title.clientWidth;
          schedule(entry);
        });
        entry.resize.observe(title);
      }
      fit(entry);
    });
  }

  window.addEventListener('resize', refresh, {passive: true});
  document.addEventListener('shopify:section:load', init);
  if (document.fonts) {
    document.fonts.ready.then(refresh);
    document.fonts.addEventListener('loadingdone', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
